import React from 'react'
import "./Radiobox.css"

function Radiobox(props) {
    return (
        <div style={props.style} className="radio">
            <label className="radio-container">{props.label}
                <input type="radio" {...props}/>
                <span className="checkmark"
                style={{ borderColor: props.isinvalid ? 'red' : 'lightgray' }}
                ></span>
            </label>
        </div>
    )
}

export default Radiobox
